// extracted by css-extract-rspack-plugin
module.exports =  {"attachmentContainer":"Form__attachmentContainer--t9Tqi","downloadLink":"Form__downloadLink--taB17"};